import * as React from "react";
const SvgCrossIconsCloseLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M18.64 7.102 13.74 12l4.899 4.898a1.23 1.23 0 0 1-1.74 1.742L12 13.74l-4.899 4.9a1.23 1.23 0 0 1-1.74 0 1.23 1.23 0 0 1 0-1.742L10.259 12 5.361 7.102a1.23 1.23 0 1 1 1.74-1.741L12 10.259l4.898-4.898a1.23 1.23 0 1 1 1.741 1.74z" }));
export default SvgCrossIconsCloseLine;
